//
import parse from 'html-react-parser';
import { PropTypes } from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { isAfter } from 'date-fns';

import FieldErrors from '../common/FieldErrors';


import DateField from '../common/DateField';

import { fromDotNetDate } from '../../helpers/dates';


//import 'react-datepicker/dist/react-datepicker.css';

import deepGetSet from '../../api/deepGetSet';
import PreferenceCenterAPI from '../../api/preferencecenter/PreferenceCenterAPI';

class PreferenceCenterSubscription extends React.Component {
  constructor(props) {
    super(props);
    //
    this.optinList = [];
    //  this.prefList = [];
    this.noTrackList = [];
    //
    this.state = {
      showMainContent: false,
      showError: false,
      loading: false,
      subscription: [],   //  elenco di liste di iscrizione
      tracking: [],       //  elenco li liste di tracking
      errors: [],         //  elenco errori form
      dirty: [],           //  elenco campi modificati
    };
  }

  componentDidMount() {
    this.loadComponent();
  }

  loadComponent = () => {
    //
    this.setState({
      loading: true
    });
    //
    this.loadSubscriberPreferences()
      .then(() => {
        //
        const subscription = [];
        const tracking = [];
        //
        this.props.prefList.forEach((listPreferences) => {
          const idList = listPreferences.IdListRelated;
          //
          const optIn = this.findObjectProperty(this.optinList, "IdList", idList, 'OptIn') || false;
          const optOut = this.findObjectProperty(this.optinList, "IdList", idList, 'OptOut') || false;
          const pending = this.findObjectProperty(this.optinList, "IdList", idList, 'Pending') || false;
          //
          const isSubscribed = optIn && !optOut && !pending;
          //
          const showFrequencyOptions = (listPreferences.EnableFrequency || listPreferences.EnablePeriod) && (isSubscribed);
          //
          const frequencyOptionFrequency = this.findObjectProperty(this.optinList, "IdList", idList, 'Send_Interval') || false;
          const frequencyOptionSuspension = (this.findObjectProperty(this.optinList, "IdList", idList, 'Date_From') &&
            this.findObjectProperty(this.optinList, "IdList", idList, 'Date_To') &&
            !frequencyOptionFrequency) || false;
          //  const frequencyOptionNoLimits = !frequencyOptionFrequency && !frequencyOptionSuspension;
          //
          const frequencyOption = frequencyOptionFrequency ? 'frequency' : (frequencyOptionSuspension ? 'suspension' : 'nolimits');
          //
          const sendInterval = this.findObjectProperty(this.optinList, "IdList", idList, 'Send_Interval') || 5;
          const suspensionFrom = this.findObjectProperty(this.optinList, "IdList", idList, 'Date_From')
            ? fromDotNetDate(this.findObjectProperty(this.optinList, "IdList", idList, 'Date_From'))
            : null;
          const suspensionTo = this.findObjectProperty(this.optinList, "IdList", idList, 'Date_To')
            ? fromDotNetDate(this.findObjectProperty(this.optinList, "IdList", idList, 'Date_To'))
            : null;
          //

          subscription.push({
            idList: idList,
            subscribe: isSubscribed,
            showFrequencyOptions: showFrequencyOptions,

            frequencyOption: frequencyOption,
            sendInterval: sendInterval,
            suspensionFrom: suspensionFrom,
            suspensionTo: suspensionTo,

            name: listPreferences.Name,
            description: listPreferences.Description,

            enableFrequency: listPreferences.EnableFrequency,
            enablePeriod: listPreferences.EnablePeriod

          });

          //  tracking
          const currentTracking = this.findObjectProperty(this.noTrackList, "IdList", idList, "Enabled");
          //  (currentTracking == null) => tracking abilitato per la lista
          //  (currentTracking.Enabled == false) => 
          if (listPreferences.EnableUserTrackMgm) { //  isSubscribed && 
            tracking.push({
              idList: idList,
              name: listPreferences.Name,
              description: listPreferences.Description,
              track: isSubscribed && (currentTracking == null),
              disabled: !isSubscribed
            });
          }


        });
        //
        this.setState({
          subscription: subscription,
          tracking: tracking,
          showMainContent: true
        });
      })
      .catch(this.handleError)
      .finally(() => {
        this.setState({
          loading: false
        });
      });
  }

  loadSubscriberPreferences() {
    return PreferenceCenterAPI.loadSubscriberPreferences(this.props.idOptin, this.props.hash, this.props.idList).then((prefSubscriber) => {
      //
      this.optinList = prefSubscriber.OptinList;
      //  this.prefList = prefSubscriber.PrefList;
      this.noTrackList = prefSubscriber.UserNoTrackList;
      //
    });
  }



  renderSubscriptionItem = (item) => {
    const frequecyOptions = [1, 5, 7, 10, 15, 30, 60];
    const idList = item.idList;
    //
    const fieldSuspensionId = `subscription_${idList}_frequencyOption_suspension`;
    const fieldSuspensionFromId = `subscription_${idList}_suspensionFrom`;
    const fieldSuspensionToId = `subscription_${idList}_suspensionTo`;

    let suspensionFromError = false;
    let suspensionToError = false;

    this.state.errors.forEach((o) => {
      if (o.fieldId == fieldSuspensionId) {
        suspensionFromError = true;
        suspensionToError = true;
      }

      if (o.fieldId == fieldSuspensionFromId) {
        suspensionFromError = true;
      }

      if (o.fieldId == fieldSuspensionToId) {
        suspensionToError = true;
      }

    });

    const fieldSuspensionFromProps = {
      fieldId: `subscription_${idList}_suspensionFrom`,
      fieldName: `subscription[${idList}].suspensionFrom`,
      fieldValue: item.suspensionFrom,
      disabled: (item.frequencyOption != 'suspension'),
      locale: this.props.intl.locale,
      isClearable: false,
      isError: suspensionFromError,
      dateFormat: 'yyyy-MM-dd',
      onChange: this.handleDateFieldChange,
      onBlur: this.handleDateFieldBlur
    };

    const fieldSuspensionToProps = {
      fieldId: `subscription_${idList}_suspensionTo`,
      fieldName: `subscription[${idList}].suspensionTo`,
      fieldValue: item.suspensionTo,
      disabled: (item.frequencyOption != 'suspension'),
      locale: this.props.intl.locale,
      isClearable: false,
      isError: suspensionToError,
      dateFormat: 'yyyy-MM-dd',
      onChange: this.handleDateFieldChange,
      onBlur: this.handleDateFieldBlur
    };




    //
    return (
      <li className="frontend-row-x-sm" key={idList}>
        <input type="checkbox" name={`subscription[${idList}].subscribe`} id={`subscription_${idList}_subscribe`} checked={item.subscribe} onChange={this.handleSubscribe} />
        <label htmlFor={`subscription_${idList}_subscribe`} className="frontend-text-bold">{item.name}</label>
        {item.description && <p className="indentazione-checkbox frontend-row-xx-sm">{item.description}</p>}
        {item.showFrequencyOptions &&
          <ul className="indentazione-checkbox">
            {item.enableFrequency &&
              <li className="input-text-inline">
                <input type="radio" name={`subscription[${idList}].frequencyOption`} id={`subscription_${idList}_frequencyOption_frequency`} value="frequency" defaultChecked={item.frequencyOption == 'frequency'} onChange={this.handleSubscriptionFormChange} />
                <label htmlFor={`subscription_${idList}_frequencyOption_frequency`}><FormattedMessage id="Load.PreferenceCenter.NoMoreThanFrequencyDays" defaultMessage="Load.PreferenceCenter.NoMoreThanFrequencyDays" /></label>
                {` `}
                <select value={item.sendInterval} name={`subscription[${idList}].sendInterval`} disabled={item.frequencyOption != 'frequency'} onChange={this.handleSubscriptionFormChange}>{frequecyOptions.map((o) => <option key={o} value={o}>{o}</option>)}</select>
                {` `}
                <span><FormattedMessage id="Load.PreferenceCenter.Days" defaultMessage="Load.PreferenceCenter.Days" /></span>
              </li>
            }

            {item.enablePeriod &&
              <li className="input-text-inline">
                <input type="radio" name={`subscription[${idList}].frequencyOption`} id={fieldSuspensionId} value="suspension" defaultChecked={item.frequencyOption == 'suspension'} onChange={this.handleSubscriptionFormChange} />
                <label htmlFor={`subscription_${idList}_frequencyOption_suspension`}><FormattedMessage id="Load.PreferenceCenter.NoMessagesFrom" defaultMessage="Load.PreferenceCenter.NoMessagesFrom" /></label>
                {` `}
                <DateField {...fieldSuspensionFromProps} />
                {` `}
                <span><FormattedMessage id="Load.PreferenceCenter.To" defaultMessage="Load.PreferenceCenter.To" /></span>
                {` `}
                <DateField {...fieldSuspensionToProps} />
                {` `}
                <FieldErrors errors={this.findFieldErrors(fieldSuspensionId)} />
              </li>
            }

            <li className="input-text-inline">
              <input type="radio" name={`subscription[${idList}].frequencyOption`} id={`subscription_${idList}_frequencyOption_nolimits`} value="nolimits" defaultChecked={item.frequencyOption == 'nolimits'} onChange={this.handleSubscriptionFormChange} />
              <label htmlFor={`subscription_${idList}_frequencyOption_nolimits`}><FormattedMessage id="Load.PreferenceCenter.FrequencyOptionsNoLimits" defaultMessage="Load.PreferenceCenter.FrequencyOptionsNoLimits" /></label>
            </li>

          </ul>

        }


      </li>
    );
  }


  renderTrackingItem = (item) => {
    const idList = item.idList;
    const trackingFieldId = `tracking_${idList}`;
    return (
      <li key={item.idList} className="frontend-row-xx-sm">
        <input type="checkbox" id={trackingFieldId} name={`tracking[${idList}].track`} checked={item.track} disabled={item.disabled} onChange={this.handleTrack} />
        <label className="frontend-text-bold" htmlFor={trackingFieldId}>{item.name}</label>
        {item.description &&
          <p className="indentazione-checkbox">{item.description}</p>
        }

      </li>
    );
  }


  /**
   * Gestione click su checkbox di iscrizione a lista
   * 
   */
  handleSubscribe = (event) => {
    const { idList, property } = this.getSubscriptionIdListAndProperty(event.target.name);
    const subscribe = event.target.checked;
    const enableFrequency = this.findObjectProperty(this.props.prefList, "IdListRelated", idList, 'EnableFrequency');
    const enablePeriod = this.findObjectProperty(this.props.prefList, "IdListRelated", idList, 'EnablePeriod');
    //
    const showFrequencyOptions = (enableFrequency || enablePeriod) && (subscribe);
    //
    this.setState((prevState) => {
      const subscription = prevState.subscription.map((item) => {
        if (item.idList == idList) {
          return Object.assign({}, item, {
            subscribe: subscribe,
            showFrequencyOptions: showFrequencyOptions
          });
        } else {
          return item;
        }
      });
      //
      //  ricalcolo liste di tracking
      const tracking = [];
      this.props.prefList.forEach((listPreferences) => {
        const subscribed = this.findObjectProperty(subscription, "idList", listPreferences.IdListRelated, "subscribe");
        const currentTracking = this.findObjectProperty(prevState.tracking, "idList", listPreferences.IdListRelated, "track");
        const prefTracking = this.findObjectProperty(this.noTrackList, "IdList", listPreferences.IdListRelated, "Enabled");

        if (listPreferences.EnableUserTrackMgm) {  //  subscribed &&
          tracking.push({
            idList: listPreferences.IdListRelated,
            name: listPreferences.Name,
            description: listPreferences.Description,
            track: subscribed && ((currentTracking !== null) ? currentTracking : ((prefTracking !== null) ? prefTracking : true)),
            disabled: !subscribed
          });

        }

      });
      //
      return {
        subscription: subscription,
        tracking: tracking
      };
    },
      () => this.validateSubscription(idList)
    );

  }




  /**
   * Gestione aggiornamento semplice di proprietà
   * 
   */
  handleSubscriptionFormChange = (event) => {
    const { idList, property } = this.getSubscriptionIdListAndProperty(event.target.name);
    const value = event.target.value;

    //
    this.setState((prevState) => {
      const subscription = prevState.subscription.map((item) => {
        if (item.idList == idList) {
          return Object.assign({}, item, {
            [property]: value
          });
        } else {
          return item;
        }
      });
      //
      return {
        subscription: subscription
      };
    },
      () => this.validateSubscription(idList));
  }


  /**
   * @deprecated
   */
  findOptinProperty = (list, idList, propertyName) => {
    let result = null;
    list.forEach((element) => {
      if (element.hasOwnProperty('IdList') && (element.IdList == idList) && element.hasOwnProperty(propertyName)) {
        result = element[propertyName];
      }
    });
    return result;
  }

  /**
   * ritorna valore di una proprietà di un oggetto all'interno di una lista
   * @param array collection array di oggetti
   * @param string identityProperty nome della proprietà che identifica l'oggetto
   * @param any identityValue valore della proprietà che identifica l'oggetto
   * @param string propertyName nome della proprietà di cui ritornare il valore
   * @return valore della proprietà
   * 
   */
  findObjectProperty = (collection, identityProperty, identityValue, propertyName) => {
    let result = null;
    collection.forEach((element) => {
      if (element.hasOwnProperty(identityProperty) && (element[identityProperty] == identityValue) && element.hasOwnProperty(propertyName)) {
        result = element[propertyName];
      }
    });
    return result;
  }


  findFieldErrors = (fieldId) => {
    let errors = [];
    this.state.errors.forEach(o => {
      if (o.fieldId == fieldId) {
        errors = o.messages;
      }
    });
    return errors;
  }



  handleUnsubscribeAll = (event) => {
    event.preventDefault();
    //
    this.setState((prevState) => {
      const subscription = prevState.subscription.map((item) => {
        return Object.assign({}, item, { subscribe: false, showFrequencyOptions: false });
      });

      const tracking = prevState.tracking.map((item) => {
        return Object.assign({}, item, { track: false, disabled: true });
      });

      return {
        subscription: subscription,
        tracking: tracking
      };
    });
  }

  handleDateFieldChange = (fieldName, date) => {
    const { idList, property } = this.getSubscriptionIdListAndProperty(fieldName);
    //
    this.setState((prevState) => {
      const subscription = prevState.subscription.map((item) => {
        if (item.idList == idList) {
          return Object.assign({}, item, {
            [property]: date
          });
        } else {
          return item;
        }
      });
      //
      return {
        subscription: subscription
      };
    },
      () => this.validateSubscription(idList)
    );
  }

  handleDateFieldBlur = (fieldName) => {
    const { idList, property } = this.getSubscriptionIdListAndProperty(fieldName);
    //
    this.setState((prevState) => {
      //
      const dirty = prevState.dirty.filter((item) => {
        return (item != fieldName);
      });
      dirty.push(fieldName);
      //
      return {
        dirty: dirty
      };
    },
      () => this.validateSubscription(idList)
    );

  }

  /**
   * Gestione click su checkbox di abilitazione tracking per lista
   * 
   */
  handleTrack = (event) => {
    const { idList, property } = this.getTrackingIdListAndProperty(event.target.name);
    const track = event.target.checked;
    //
    this.setState((prevState) => {
      const tracking = prevState.tracking.map((item) => {
        if (item.idList == idList) {
          return Object.assign({}, item, { track: track });
        } else {
          return item;
        }
      });
      //
      return {
        tracking: tracking
      };
    });

  }

  handleUntrackAll = (event) => {
    event.preventDefault();
    //
    this.setState((prevState) => {
      const tracking = prevState.tracking.map((item) => {
        return Object.assign({}, item, { track: false });
      });
      //
      return {
        tracking: tracking
      };
    });
  }

  handleFormSubmit = (event) => {
    event.preventDefault();
    //
    this.setState({
      loading: true
    });
    //
    const { idOptin, hash, idList, idNL } = this.props;
    PreferenceCenterAPI.saveSubscriberPreferences(idOptin, hash, idList, idNL, this.state.subscription, this.state.tracking)
      .then(res => {
        //  notify parent
        this.props.onSave();
        //  reload?
      })
      .catch(this.handleError)
      .finally(() => {
        this.setState({
          loading: false
        });
      });
  }

  handleError = () => {
    this.props.onError(this.props.intl.formatMessage({ id: 'Load.Common.Error', defaultMessage: 'Load.Common.Error' }));
  }



  validateSubscription = (idList) => {
    //
    this.state.subscription.filter((o) => o.idList == idList).forEach(item => {
      //  reset errori per opzione suspension di questa lista
      const fieldSuspensionId = `subscription_${idList}_frequencyOption_suspension`;
      const fieldSuspensionFromId = `subscription_${idList}_suspensionFrom`;
      const fieldSuspensionToId = `subscription_${idList}_suspensionTo`;
      const errors = this.state.errors.filter((o) => (o.fieldId != fieldSuspensionId) && (o.fieldId != fieldSuspensionFromId) && (o.fieldId != fieldSuspensionToId));
      //
      if (item.frequencyOption == 'suspension') {
        if (!item.suspensionFrom) {
          errors.push({
            fieldId: fieldSuspensionFromId,
            messages: [this.props.intl.formatMessage({ 'id': 'Load.PreferenceCenter.ErrorSuspensionDates', defaultMessage: 'Load.PreferenceCenter.ErrorSuspensionDates' })]
          });
          //
        }

        if (!item.suspensionTo) {
          errors.push({
            fieldId: fieldSuspensionToId,
            messages: [this.props.intl.formatMessage({ 'id': 'Load.PreferenceCenter.ErrorSuspensionDates', defaultMessage: 'Load.PreferenceCenter.ErrorSuspensionDates' })]
          });
          //
        }



        if (item.suspensionFrom && item.suspensionTo && !isAfter(item.suspensionTo, item.suspensionFrom)) {
          errors.push({
            fieldId: fieldSuspensionId,
            messages: [this.props.intl.formatMessage({ 'id': 'Load.PreferenceCenter.ErrorSuspensionDates', defaultMessage: 'Load.PreferenceCenter.ErrorSuspensionDates' })]
          });
          //
        }
      }

      //
      this.setState({
        errors: errors
      });
    });
  }

  getSubscriptionIdListAndProperty(inputName) {
    const matches = inputName.match(/subscription\[(\d+)]\.(\w+)$/);
    if (matches && matches.length) {
      return { idList: matches[1], property: matches[2] };
    }
  }

  getTrackingIdListAndProperty(inputName) {
    const matches = inputName.match(/tracking\[(\d+)]\.(\w+)$/);
    if (matches && matches.length) {
      return { idList: matches[1], property: matches[2] };
    }
  }

  render() {
    //  se idNL == 0 presumo sia in modalità preview e disabilito il save
    const { intl, prefTexts, idNL } = this.props;
    const disableSubmit = (idNL == 0) || (this.state.errors.length > 0) || this.state.loading;
    //
    return (
      <div className="frontend-box frontend-row">

        {this.state.showMainContent &&
          <form onSubmit={this.handleFormSubmit}>
            {/* Iscrizione */}
            <div className="pref-center_container_iscrizione frontend-row">
              {deepGetSet(prefTexts, 'subUnsubData.sectionTitle') &&
                <div className="frontend-row-sm"><h1>{deepGetSet(prefTexts, 'subUnsubData.sectionTitle')}</h1></div>
              }

              {deepGetSet(prefTexts, 'subUnsubData.sectionDescr') &&
                <div className="frontend-row-x-sm"><h3>{parse(deepGetSet(prefTexts, 'subUnsubData.sectionDescr'))}</h3></div>
              }

              <div>
                <ul className="frontend-row-x-sm">
                  {this.state.subscription.map((o) => this.renderSubscriptionItem(o))}
                </ul>
                {this.state.subscription.length > 2 &&
                  <strong><a onClick={this.handleUnsubscribeAll} href="#"><FormattedMessage id="Load.PreferenceCenter.UncheckAll" defaultMessage="Load.PreferenceCenter.UncheckAll" /></a></strong>
                }

              </div>


            </div>

            {this.props.showTracking && (this.state.tracking.length > 0) &&
              <React.Fragment>
                <div className="frontend-divider is-in-box frontend-row" />
                <div className="pref-center_container_tracciamento frontend-row">
                  {deepGetSet(prefTexts, 'trackStatData.sectionTitle') &&
                    <div className="frontend-row-sm"><h1>{deepGetSet(prefTexts, 'trackStatData.sectionTitle')}</h1></div>
                  }

                  {deepGetSet(prefTexts, 'trackStatData.sectionDescr') &&
                    <div className="frontend-row-x-sm"><h3>{parse(deepGetSet(prefTexts, 'trackStatData.sectionDescr'))}</h3></div>
                  }

                  <div className="frontend-row-xx-sm"><h4><FormattedMessage id="Load.PreferenceCenter.EnableStatsTracking" defaultMessage="Load.PreferenceCenter.EnableStatsTracking" /></h4></div>
                  <div>
                    <ul className="frontend-row-xx-sm">
                      {this.state.tracking.map((o) => this.renderTrackingItem(o))}
                    </ul>
                    {this.state.tracking.length > 2 &&
                      <strong><a onClick={this.handleUntrackAll} href="#"><FormattedMessage id="Load.PreferenceCenter.UncheckAll" defaultMessage="Load.PreferenceCenter.UncheckAll" /></a></strong>
                    }
                  </div>

                </div>
              </React.Fragment>
            }


            <div className="frontend-divider is-in-box frontend-row-sm" />

            <div className="frontend-row-sm">
              <button className="frontend_main-button" type="submit" disabled={disableSubmit}>{prefTexts.personalizationData.callToAction}</button>
            </div>

          </form>
        }

        {this.state.showError &&
          <FormattedMessage id="Load.Common.Error" defaultMessage="Load.Common.Error" />
        }

      </div>
    );
  }
}

PreferenceCenterSubscription.defaultProps = {
  showTracking: false
};

PreferenceCenterSubscription.propTypes = {
  prefTexts: PropTypes.object.isRequired,
  prefList: PropTypes.arrayOf(PropTypes.object).isRequired,
  showTracking: PropTypes.bool,

  idOptin: PropTypes.number.isRequired,
  hash: PropTypes.string.isRequired,
  idList: PropTypes.number.isRequired,
  idNL: PropTypes.number.isRequired,
  //
  onSave: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};


export default injectIntl(PreferenceCenterSubscription);